import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["result", "title", "body"];

  connect() {
    // console.log(this.titleTarget.textContent);
    // console.log(window.location.href);
    // console.log(this.resultTarget.textContent);
  }

  async share(e) {
    e.preventDefault();

    const shareData = {
      title: this.titleTarget.textContent,
      body: this.bodyTarget.textContent,
      url: window.location.href,
    };
    try {
      await navigator.share(shareData);
      //   this.resultTarget.textContent = "MDN shared successfully";
    } catch (err) {
      console.log(err);
    }
  }
}
